// extracted by mini-css-extract-plugin
module.exports = {"title":"NavMenu_title__2C706","navButton":"NavMenu_navButton__1B7yi"};